/* eslint-disable no-unused-vars */
import React, { useContext, useEffect, useState } from "react";
import Headline from "~/assets/js/components/Typography/Headline";
import GoBackTitle from "../../components/GoBackTitle";
import OrderCard from "~/assets/js/components/OrderCard";
import { CustomerAreaContext } from "~/assets/js/pages/CustomerArea/CustomerAreaProvider";
import { ACTIONS } from "../../CustomerAreaProvider";
import { useUserOrders } from "~/assets/js/Api/userApi";
import OverlayLoader from "~/assets/js/components/Loaders/OverlayLoader";

const PATH = "ordersOverview";

/**
 * Will be updated in the next sprint
 * with either an endless scroll functionality
 * or a bigger request to fetch all the data
 */
const OrdersOverview = () => {
    const [year, _setYear] = useState(new Date().getFullYear());
    const [displayedOrders, setOrders] = useState({});
    const { dispatch } = useContext(CustomerAreaContext);
    const { orders, isError, isLoading } = useUserOrders();

    const orderSelect = (order) => {
        dispatch({ type: ACTIONS.SET_ORDER, payload: order });
    };

    useEffect(() => {
        setOrders({ [year]: orders });
    }, [year, orders]);

    if (isError || (orders && !orders.length)) {
        return <GoBackTitle path={PATH} />;
    }

    return (
        <>
            <GoBackTitle path={PATH} />
            <Headline size={6} resizable>
                {year}
            </Headline>

            {isLoading ? (
                <OverlayLoader />
            ) : (
                orders
                    .sort((a, b) => {
                        const dateA = new Date(a.slot_begin);
                        const dateB = new Date(b.slot_begin);
                        if (dateA <= dateB) {
                            return 1;
                        } else {
                            return -1;
                        }
                    })
                    .map((order) => (
                        <OrderCard
                            order={order}
                            handleClick={() => orderSelect(order)}
                            key={order.id}
                        />
                    ))
            )}
        </>
    );
};

export default OrdersOverview;
